import { cn } from '../../lib/cn'

interface StepChipsProps {
  steps: string[]
  /** 1-based index of the current step. */
  current: number
  className?: string
}

/** Numbered step dots: done = moss, current = ink, future = paper-deep. */
export function StepChips({ steps, current, className }: StepChipsProps) {
  return (
    <div className={cn('flex flex-wrap items-center gap-x-4 gap-y-2', className)}>
      {steps.map((label, i) => {
        const n = i + 1
        const done = n < current
        const active = n === current
        return (
          <div key={label} className="flex items-center gap-2">
            <span
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full font-mono text-[11px]',
                done && 'bg-moss text-paper-surface',
                active && 'bg-ink text-paper-panel',
                !done && !active && 'bg-paper-deep text-ink-faint',
              )}
            >
              {String(n).padStart(2, '0')}
            </span>
            <span
              className={cn(
                'font-mono text-[10.5px] uppercase tracking-label',
                active ? 'text-ink' : 'text-ink-faint',
              )}
            >
              {label}
            </span>
          </div>
        )
      })}
    </div>
  )
}
